import { VcsReportingChoices } from '~/types/types'

export const formatToggleValue = (enabled: boolean): string => (enabled ? 'On' : 'Off')

const capitalizeLabel = (value: string): string => {
  if (!value) {
    return value
  }

  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const formatVcsReportingOptionLabel = (
  option: VcsReportingChoices,
  providerPrLabel: string,
  inlineCommentsOption: VcsReportingChoices = 'INLINE_COMMENTS' as VcsReportingChoices
): string => {
  switch (option) {
    case VcsReportingChoices.PrComment:
      return `${capitalizeLabel(providerPrLabel)} comments`
    case inlineCommentsOption:
      return 'Inline comments'
    default:
      return 'Integration setting'
  }
}
